import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SchemeActionButtons, SchemeTypes, SelectedScheme } from './model';
import { RootState } from '../root/root-types';

export const SCHEMES_FEATURE_KEY = 'schemesData';

export interface SchemesState {
  selectedScheme: SchemeTypes;
  selectedTab: SchemeActionButtons;
  selectedFilterChip: string;
  selectedSchemes: SelectedScheme[];
}

export const initialSchemesState: SchemesState = {
  selectedScheme: SchemeTypes.BUYXGETY,
  selectedTab: SchemeActionButtons.CONDITIONS,
  selectedFilterChip: 'All',
  selectedSchemes: [],
};

export const schemesSlice = createSlice({
  name: SCHEMES_FEATURE_KEY,
  initialState: initialSchemesState,
  reducers: {
    updateSelectedScheme(state, action: PayloadAction<SchemeTypes>) {
      state.selectedScheme = action.payload;
    },
    updateSelectedTab(state, action: PayloadAction<SchemeActionButtons>) {
      state.selectedTab = action.payload;
    },
    updateSelectedSchemes(state, action: PayloadAction<SelectedScheme[]>) {
      state.selectedSchemes = action.payload;
    },
  },
});

export const schemeReducer = schemesSlice.reducer;

export const {
  updateSelectedScheme,
  updateSelectedTab,
  updateSelectedSchemes,
} = schemesSlice.actions;

export const getSchemesSliceState = (rootState: RootState): SchemesState =>
  rootState[SCHEMES_FEATURE_KEY];

export const getSelectedScheme = createSelector(
  getSchemesSliceState,
  (state) => state.selectedScheme
);

export const getSelectedTab = createSelector(
  getSchemesSliceState,
  (state) => state.selectedTab
);

export const getSelectedSchemes = createSelector(
  getSchemesSliceState,
  (state) => state.selectedSchemes
);
